import { __decorate } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { v, w } from '@dojo/framework/core/vdom';
import { storeInject } from '@dojo/framework/stores/StoreInjector';
import { lccstore } from 'lcc-state';
import css from '../css/lptoolcard.m.css';
const genTransition = (pos) => {
    const styles = getComputedStyle(document.body);
    const cardwidth = styles.getPropertyValue('--card-width').trim();
    const cardmargin = styles.getPropertyValue('--card-margin').trim();
    return `translate(calc((${cardwidth} + ${cardmargin}) * ${-pos}), 0)`;
};
let LPCarousel = class LPCarousel extends I18nThemed {
    pos = 0;
    cards = 0;
    transition = 'translate(0,0)';
    nextCard(event) {
        event && event.stopPropagation();
        let { pos } = this;
        pos += 1;
        if (pos < this.cards) {
            this.pos = pos;
            this.transition = genTransition(pos);
            this.invalidate();
        }
    }
    prevCard(event) {
        event && event.stopPropagation();
        let { pos } = this;
        if (pos > 0) {
            pos -= 1;
            this.pos = pos;
            this.transition = genTransition(pos);
            this.invalidate();
        }
        else {
            this.transition = 'translate(0,0)';
            this.invalidate();
        }
    }
    render_kids(kids) {
        return kids.map((kid) => {
            const { widget } = kid;
            const params = { ...kid, transition: this.transition };
            delete params['widget'];
            return w(widget, { ...params });
        });
    }
    get_nextstep(kids) {
        const { toolstate } = this.properties;
        const incompleteKids = kids.filter((k) => {
            const action = k.action;
            return !toolstate || !toolstate[action] || !toolstate[action].complete;
        });
        const kid = incompleteKids[0];
        return kid;
    }
    render_nextstep(kid) {
        const { widget } = kid;
        const params = {
            ...kid,
            transition: 'translate(0,0)',
            isNextStep: true
        };
        delete params['widget'];
        return w(widget, { ...params });
    }
    get_nls() {
        const { get, path } = lccstore;
        const dynls = get(path('dynls'));
        const bundle = dynls.get('settings');
        if (!bundle) {
            return { isPlaceholder: true, format: () => '', messages: {} };
        }
        return this.localizeBundle(bundle);
    }
    render() {
        const { isPlaceholder, messages } = this.get_nls();
        if (isPlaceholder) {
            return null;
        }
        const nextStepText = messages[`lpcarousel_nextstep`] || '';
        const { classes = [], element = 'div', name, kids } = this.properties;
        this.cards = kids.length;
        const styles = getComputedStyle(document.body);
        const cardcount = Number(styles.getPropertyValue('--card-count').trim());
        const { pos, cards } = this;
        const nextstepKid = this.get_nextstep(kids);
        const nextstepName = nextstepKid.name || null;
        return v(element, {
            key: name,
            role: 'menu',
            classes: [this.theme(css.carouselBlock), ...classes],
            xqa: `lpcarousel ${name}`
        }, [
            v('div', {
                key: 'nextstep',
                xqa: 'carousel nextstep',
                classes: [this.theme(css.nextstepBlock), nextstepName]
            }, [
                v('div', { classes: [this.theme(css.nextstepBox)] }, [
                    v('h1', { classes: [this.theme(css.nextstepTitle)] }, [nextStepText]),
                    v('div', { classes: [this.theme(css.nextstep)] }, [this.render_nextstep(nextstepKid)])
                ])
            ]),
            v('div', {
                key: 'prev',
                xqa: 'carousel previous',
                classes: [this.theme(css.previous)],
                onclick: (event) => {
                    this.prevCard(event);
                }
            }, [pos > 0 ? v('i', { classes: ['fa', 'fa-chevron-left', this.theme(css.largeArrow)] }) : null]),
            v('div', { key: 'carousel', classes: [this.theme(css.carousel)] }, this.render_kids(kids)),
            v('div', {
                key: 'next',
                xqa: 'carousel next',
                classes: [this.theme(css.next)],
                onclick: (event) => {
                    this.nextCard(event);
                }
            }, [
                pos < cards - cardcount
                    ? v('i', { classes: ['fa', 'fa-chevron-right', this.theme(css.largeArrow)] })
                    : null
            ])
        ]);
    }
};
LPCarousel = __decorate([
    theme(css),
    storeInject({
        name: 'user-state',
        paths: [['toolstate']],
        getProperties: (store) => {
            const { get, path } = store;
            return {
                toolstate: get(path('toolstate'))
            };
        }
    })
], LPCarousel);
export { LPCarousel };
export default LPCarousel;
